import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./CardCarousel.css";
import { Heading } from "~/components/elements/Heading";
import PortableText, {
  IPortableText,
} from "~/components/portableText/PortableText";
import { ButtonLink } from "~/components/elements/ButtonLink";
import clsx from "clsx";

// @ts-ignore
import ArrowOutward from "@material-design-icons/svg/filled/arrow_outward.svg?react";
import { ILinkProps } from "~/components/elements/Link";
import { Paragraph } from "~/components/elements/Paragraph";
import { truncate } from "~/styles/functions";

export type CardCarouselProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    card: {
      title?: string;
      text?: string;
      link?: ILinkProps;
    };
    index?: number;
    theme?: "light" | "colour";
    fontSize?: "sm" | "xs";
    heightFull?: boolean;
    truncateLength?: number;
  };

export const CardCarousel = ({
  theme,
  card,
  index,
  fontSize = "sm",
  heightFull = false,
  truncateLength,
  ...props
}: CardCarouselProps) => {
  const { title, text, link } = card;
  const { className } = props;

  return (
    <div className={styles.cardContainer({ heightFull })}>
      <div
        className={clsx(className, styles.card({ theme: theme, heightFull }))}
      >
        <div className={styles.text}>
          {index && (
            <Heading as="p" size="h4">
              {`${index.toString().padStart(2, "0")}.`}
            </Heading>
          )}
          {title && (
            <div className={styles.heading}>
              <Heading as="h3" size="h3" uppercase bold>
                {truncateLength ? truncate(title, truncateLength) : title}
              </Heading>
            </div>
          )}
          {text && <Paragraph size={fontSize}>{text}</Paragraph>}
        </div>
        {link && (
          <div className={styles.buttonContainer}>
            <ButtonLink
              isPrimary={false}
              theme={theme === "colour" ? "light" : "colour"}
              link={link}
              icons={{ iconPrimary: <ArrowOutward /> }}
            >
              {link.text}
            </ButtonLink>
          </div>
        )}
      </div>
      <div className={styles.triangle({ theme: theme })}></div>
    </div>
  );
};
